"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaRelDiarioCabecalho = exports.yupRelDiarioCabecalho = void 0;
const yup = __importStar(require("yup"));
exports.yupRelDiarioCabecalho = yup.object({
    nomeEscola: yup.string().required().label('Nome da escola'),
    titulo: yup.string().required().label('Titulo da escola'),
    endereco: yup.string().required().label('Endereço da escola'),
    cnpj: yup.string().required().label('CNPJ da escola'),
    telefone: yup.string().required().label('Telefone da escola'),
    fax: yup.string().required().label('Fax da escola'),
    cep: yup.string().required().label('CEP da escola'),
    cidade: yup.string().required().label('Cidade da escola'),
    estado: yup.string().required().label('UF da escola'),
    codigoEscola: yup.string().required().label('Código da escola'),
    mantenedora: yup.string().required().label('Mantenedora da escola'),
    etapas: yup.string().required().label('Número de etapas'),
    emailSecretaria: yup.string().required().label('E-mail da secretaria'),
    nomeEtapa: yup.string().required().label('Nome da etapa'),
    nomeEtapaAdjetivo: yup.string().required().label('Adjetivo do nome da Etapa'),
    etapa: yup.string().required().label('Etapa atual'),
    codigoProfessor: yup.string().required().label('Código do professor'),
    nomeProfessor: yup.string().required().label('Nome do professor'),
    nomeMateria: yup.string().required().label('Nome da Matéria'),
    turma: yup.string().required().label('Turma'),
    nomeSerie: yup.string().required().label('Nome da série'),
    aulasDadas: yup.number().label('Número de aulas dadas'),
    aulasPrevistas: yup.number().label('Número de aulas previstas'),
    grau: yup.string().required().label('Grau do curso'),
    nomeCurso: yup.string().required().label('Nome do Curso'),
    anoLetivo: yup.string().required().label('Ano Letivo'),
    usavirgula: yup.string().required().label('Usar virgula'),
    nomeEmpresa: yup.string().label('Nome da Empresa'),
    codigoEmpresa: yup.string().label('Código da Empresa'),
    nomeCoordenador: yup.string().label('Nome do Coordenador'),
    mostrarMateria: yup.boolean().required().label('Mostrar Matéria'),
    turno: yup.string().required().label('Turno da Turma'),
    enderecoOnline: yup.string().required().label('Endereço do Módulo Online'),
});
exports.schemaRelDiarioCabecalho = exports.yupRelDiarioCabecalho.shape({});
